import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

export const supplierOrdersUrl = '/supplier-orders'
export const supplierOrderDetailUrl = `/supplier-orders/:orderNumber`
export const supplierOrderPackingSlipDetailUrl = `/supplier-orders/:orderNumber/packing-slip/:packingSlipNumber`
export const supplierOrderPackingSlipPdfViewUrl = `/supplier-orders/:orderNumber/packing-slip/:packingSlipNumber/view`

export const getSupplierOrderPackingSlipDetailUrl = (orderNumber: string, packingSlipNumber: string) =>
  `/supplier-orders/${encodeURIComponent(orderNumber)}/packing-slip/${encodeURIComponent(packingSlipNumber)}`

export const getSupplierOrderPackingSlipPdfViewUrl = (orderNumber: string, packingSlipNumber: string) =>
  `${getSupplierOrderPackingSlipDetailUrl(orderNumber, packingSlipNumber)}/view`
export const supplierOrderPrintUrl = `/supplier-orders/:orderUUID(${UUIDPathRegex})/print`
export const supplierOrderWholesalersUrl = `/supplier-orders/:orderUUID(${UUIDPathRegex})/wholesalers`
export const supplierOrderChecklistPrintUrl =
  `/supplier-orders/:orderUUID(${UUIDPathRegex})/checklist/` + `:checklistUUID(${UUIDPathRegex})/print`
